import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class CheckCheckBox extends Icon {
  render() {
    let { color, size, style, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        style={style}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
      >
        <g fill={color}>
          <polygon points="7.1,14.7 2.5,11.9 3.6,10.2 7.3,12.4 11.9,3.5 13.7,4.4 8.6,14.3 " />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/CheckCheckBox.js